import { useEffect } from "react";

export default function FloatingButton() {
  useEffect(() => {
    const update = () => {
      document.body.style.paddingBottom = window.innerWidth < 768 ? "80px" : "";
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      document.body.style.paddingBottom = "";
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <a
      href="tel:0374473240"
      className="fixed bottom-4 left-4 right-4 z-50 md:hidden bg-[#E8734A] text-white py-4 rounded-full font-semibold text-base flex items-center justify-center gap-2 hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap"
    >
      <i className="ri-phone-line text-lg"></i>
      Appeler
    </a>
  );
}